import { useQuery } from '@tanstack/react-query'
import { getShellContext } from './shell-context-service'
import { useSession } from '../auth/use-session'
import { useDataSource } from '../../lib/data-source'
export const shellContextQueryKeys = { all: ['shell'] as const }
export function useShellContext() {
  const session = useSession()
  const mode = useDataSource('shell', session.data?.user)
  return {
    mode,
    ...useQuery({
      queryKey: [...shellContextQueryKeys.all, mode.scope, mode.source],
      enabled: mode.status === 'ready',
      queryFn: () => getShellContext(mode.source, session.data?.user),
      refetchInterval: 60_000,
    }),
  }
}
